import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Box,
  Modal,
  Input,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Footer from "../Footer/Footer";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { format, formatISO } from "date-fns";
import config from "../config";
import Tooltip from "bootstrap/js/dist/tooltip";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Alert } from "@mui/material";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

const EquipmentReservation = () => {
  const [events, setEvents] = useState([]);
  const [reservedBy, setReservedBy] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [purposeOfEquipment, setPurposeOfEquipment] = useState("");
  const [noOfPersons, setNoOfPersons] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModalRequest, setOpenModalRequest] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [EmpCode, setEmpCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [boardroomData, setBoardroomData] = useState({});
  const [data, setData] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [equipmentName, setEquipmentName] = useState("");
  const today = dayjs().startOf("day");
  const minTime = dayjs().set('hour', 8).set('minute', 0).set('second', 0);
  const maxTime = dayjs().set('hour', 19).set('minute', 0).set('second', 0);

  const [maxPersons, setMaxPersons] = useState(0);
  const [personsError, setPersonsError] = useState('');
  const [editMaxPersons, setEditMaxPersons] = useState(0);
  const [editPersonsError, setEditPersonsError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  const handleAgree = () => {
    setOpenDialog(false); // ✅ Jabra selection confirm
  };

  const handleDisagree = () => {
    setOpenDialog(false);
    setEquipmentName(""); // ✅ reset form
  };

  const zoomCapacity = {
    'Zoom I': 500,
    'Zoom II': 100,
    'Zoom III': 100,
  };

  useEffect(() => {
    if (selectedLocation === 'HeadOffice' && equipmentName) {
      setMaxPersons(zoomCapacity[equipmentName] || 0);
    } else if (selectedLocation === 'Factory' && equipmentName) {
      setMaxPersons(zoomCapacity[equipmentName] || 0);
    } else {
      setMaxPersons(0);
    }
  }, [selectedLocation, equipmentName]);

  useEffect(() => {
    if (selectedEvent?.selectedLocation === 'HeadOffice' && selectedEvent?.equipmentName) {
      setEditMaxPersons(zoomCapacity[selectedEvent.equipmentName] || 0);
    } else if (selectedEvent?.selectedLocation === 'Factory' && selectedEvent?.equipmentName) {
      setEditMaxPersons(zoomCapacity[selectedEvent.equipmentName] || 0);
    } else {
      setEditMaxPersons(0);
    }
  }, [selectedEvent?.selectedLocation, selectedEvent?.equipmentName]);

  const handleEquipmentChange = (e) => {
    setEquipmentName(e.target.value);

      if (e.target.value === "Jabra Audio Device") {
      setOpenDialog(true);
    }
  };

  const handleNoOfPersonsChange = (e) => {
    const value = e.target.value;
    let parsedValue = parseInt(value);

    if (value === '') {
      setNoOfPersons(0);
      setPersonsError('');
    } else if (isNaN(parsedValue)) {
      setNoOfPersons(0);
      setPersonsError('');
    } else {
      setNoOfPersons(parsedValue);
      if (parsedValue > maxPersons) {
        setPersonsError(`Maximum ${maxPersons} persons allowed.`);
      } else {
        setPersonsError('');
      }
    }
  };

  const handleNoOfPersonsChangeEdit = (e) => {
    const value = e.target.value;
    let parsedValue = parseInt(value);

    if (value === '') {
      setSelectedEvent({ ...selectedEvent, noOfPersons: 0 });
      setEditPersonsError('');
    } else if (isNaN(parsedValue)) {
      setSelectedEvent({ ...selectedEvent, noOfPersons: 0 });
      setEditPersonsError('');
    } else {
      setSelectedEvent({ ...selectedEvent, noOfPersons: parsedValue });
      if (parsedValue > editMaxPersons) {
        setEditPersonsError(`Maximum ${editMaxPersons} persons allowed.`);
      } else {
        setEditPersonsError('');
      }
    }
  };

  useEffect(() => {
    try {
      const rawAccessLevel = localStorage.getItem("Boardroom_AccessLevel");
      const accessLevel = rawAccessLevel
        ? rawAccessLevel.replace(/"/g, "")
        : null;

      const storedEmpCode = localStorage.getItem("Empcode");

      if (accessLevel) {
        // console.log("Access Level:", rawAccessLevel);
        setLoggedInUser(accessLevel);
      } else {
        console.warn("Invalid AccessLevel format in localStorage.");
      }

      if (storedEmpCode) {
        setEmpCode(storedEmpCode);
        // console.log("EMP CODE", storedEmpCode)
      }
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
    }
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const Empcode = localStorage.getItem("Empcode");
      if (!Empcode) {
        setReservedBy("Guest");
        setUserEmail("guest@pharmevo.biz");
        return;
      }

      try {
        const response = await axios.get(`${config.API_BASE_URL}/getUsers/${Empcode}`);
        const userData = response.data;
        setReservedBy(`${userData.EmployeeName}`);
        setUserEmail(`${userData.Email}`);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setReservedBy("Unknown User");
        setUserEmail("Unknown Email");
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    axios
      .get(`${config.API_BASE_URL}/equipment/getAvailableEquipments`)
      .then((response) => {
        if (response.data && Object.keys(response.data).length > 0) {
          setData(response.data);
        } else {
          setData({});
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  const availableEquipments = data && selectedLocation ? data[selectedLocation] || [] : [];

  const fetchEquipmentsReservation = async (startDate, endDate) => {
    try {
      const response = await axios.get(
        `${config.API_BASE_URL}/equipmentReservation/getEquipmentReservations`,
        {
          params: {
            start: startDate.toISOString(),
            end: endDate.toISOString(),
          },
        }
      );

      const fetchedEvents = response.data.map((res) => ({
        id: res.equipmentReservationId,
        title: res.equipmentName,
        selectedLocation: res.selectedLocation,
        reservedBy: res.reserveBy,
        userEmail: res.userEmail,
        start: new Date(res.selectedStartDate),
        end: new Date(res.selectedEndDate),
        allDay: false,
        EmpCode: res.EmpCode,
        purposeOfEquipment: res.purposeOfEquipment,
        status: res.status,
        isReturned: res.isReturned,
      }));

      // console.log("BRRRRRRRRRRRRRRR", fetchedEvents);
      setEvents(fetchedEvents);
    } catch (error) {
      console.error("Error fetching Equipments:", error);
    }
  };

  useEffect(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );

    fetchEquipmentsReservation(firstDayOfMonth, lastDayOfMonth);
  }, []);

  const isSaveDisabled =
    !selectedLocation ||
    !purposeOfEquipment ||
    !equipmentName ||
    !startDate ||
    !endDate ||
    endDate.isSame(startDate) ||
    endDate.isBefore(startDate);

  const resetFormFields = () => {
  setSelectedLocation("");
  setEquipmentName("");
  setStartDate(null);
  setEndDate(null);
  setPurposeOfEquipment("");
};

  const handleBookReservation = async () => {
    if (!equipmentName || !startDate || !endDate || !selectedLocation || !purposeOfEquipment) {
      //ISKO CHANGE KRNA BHAE TOAST MEIN YA ERROR FIELD MEIN AJEEB
      toast.error("Please fill all fields!");
      return;
    }


    if (endDate.isSame(startDate) || endDate.isBefore(startDate)) {
      toast.error("End time must be after start time.");
      return;
    }

const parseDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === "string") return new Date(value.replace(" ", "T"));
  return new Date(value);
};

const isConflict = events.find((event) => {
  const eventStart = parseDate(event.start || event.selectedStartDate);
  const eventEnd = parseDate(event.end || event.selectedEndDate);
  const newStart = parseDate(startDate);
  const newEnd = parseDate(endDate);

  const sameEquipment =
    event.equipmentName === equipmentName ||
    event.title?.toLowerCase().includes(equipmentName.toLowerCase());

  if (!sameEquipment) return false;

  const overlap =
    (newStart >= eventStart && newStart < eventEnd) ||
    (newEnd > eventStart && newEnd <= eventEnd) ||
    (newStart <= eventStart && newEnd >= eventEnd);

  return overlap;
});


    if (isConflict) {
      toast.warning(
        `The equipment "${equipmentName}" is already booked from ${new Date(isConflict.start).toLocaleString()} to ${new Date(isConflict.end).toLocaleString()}.`
      );

      setSelectedLocation("");
      setEquipmentName("");
      setStartDate(null);
      setEndDate(null);
      setPurposeOfEquipment("");
      return;
    }

    const newEvent = {
      title: equipmentName,
      equipmentName,
      reserve: reservedBy,
      userEmail: userEmail,
      start: (new Date(startDate).toLocaleString()),
      end: (new Date(endDate).toLocaleString()),
      allDay: false,
      EmpCode: EmpCode,
      // remarks: remarks,
      selectedLocation: selectedLocation,
      purposeOfEquipment: purposeOfEquipment,
    };

    setEvents([...events, newEvent]);
    // console.log({ newEvent });
    try {
      await axios.post(
        `${config.API_BASE_URL}/equipmentReservation/createEquipmentReservation`,
        {
          equipmentName,
          reserveBy: reservedBy,
          userEmail: userEmail,
          selectedStartDate: (new Date(startDate).toLocaleString()),
          selectedEndDate: (new Date(endDate).toLocaleString()),
          // remarks,
          EmpCode: EmpCode,
          selectedLocation: selectedLocation,
          purposeOfEquipment: purposeOfEquipment,
        }
      );
      // console.log("Payload being sent:", {
      //   equipmentName,
      //   reservedBy,
      //   selectedStartDate: new Date(startDate).toISOString(),
      //   selectedEndDate: new Date(endDate).toISOString(),
      //   EmpCode,
      //   selectedLocation,
      //   purposeOfEquipment,
      // });

      toast.success(
        `You booked "${equipmentName}" for "${purposeOfEquipment}" from ${new Date(startDate).toLocaleString()} to ${new Date(endDate).toLocaleString()}.`
      );

        resetFormFields();
        
        await fetchEquipmentsReservation();
    } catch (error) {
      console.error("Error saving reservation:", error);
    }
  };

  const handleEventClick = (clickInfo) => {
    const eventDetails = {
      title: clickInfo.event.title,
      start: clickInfo.event.start.toLocaleString(),
      end: clickInfo.event.end.toLocaleString(),
      reservedBy: clickInfo.event.extendedProps.reservedBy,
      userEmail: clickInfo.event.extendedProps.userEmail,
      EmpCode: clickInfo.event.extendedProps.EmpCode,
      // remarks: clickInfo.event.extendedProps.remarks,

      purposeOfEquipment: clickInfo.event.extendedProps.purposeOfEquipment,
      status: clickInfo.event.extendedProps.status,
      equipmentReservationId: clickInfo.event.id,
      equipmentName: clickInfo.event.title,
      selectedLocation: clickInfo.event.extendedProps.selectedLocation,
      extendedProps: clickInfo.event.extendedProps,
    };

    // console.log("BHAI YEH LAY", { eventDetails });

    setSelectedEvent(eventDetails);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedEvent(null);
  };

  const handleOpenModalRequest = () => {
    // console.log("Event Data:", { selectedEvent });

    setOpenModal(false);
    setOpenModalRequest(true);
  };

  const handleCloseModalRequest = () => {
    setOpenModalRequest(false);
    setSelectedEvent(null);
  };

  const handleOpenModalEdit = () => {
    setOpenModal(false);
    setOpenModalEdit(true);
  };
  const handleCloseModalEdit = () => {
    setOpenModalEdit(false);
    setSelectedEvent(null);
  };

  const handleDateChange = (info) => {
    const startDate = new Date(info.start);
    const endDate = new Date(info.end);
    fetchEquipmentsReservation(startDate, endDate);
  };

  // console.log({ events }, `check state`);

  const handleDelete = async (equipmentReservationId) => {
    if (!equipmentReservationId) {
      toast.error("Something went wrong!");
      return;
    }
    const confirmDelete = window.confirm("Are you sure you want to delete this reservation?");
    if (!confirmDelete) return;

    try {
      const response = await fetch(`${config.API_BASE_URL}/equipmentReservation/deleteEquipmentReservation/${equipmentReservationId}`, {
        method: "DELETE"
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Equipment Reservation deleted successfully!");
        window.location.reload();
      } else {
        console.error(result.message || "Failed to delete equipment reservation");
      }
    } catch (error) {
      console.error("Error deleting equipment reservation:", error);
      console.error("Error deleting quipment reservation");
    }
  };

  const handleReturned = async (equipmentReservationId) => {
    if (!equipmentReservationId) {
      toast.error("Something went wrong!");
      return;
    }

    const confirmReturn = window.confirm("Are you sure this item was returned?");
    if (!confirmReturn) return;

    try {
      const response = await fetch(`${config.API_BASE_URL}/equipmentReservation/markReturned/${equipmentReservationId}`, {
        method: "POST", // ✅ changed from DELETE to POST
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Equipment marked as returned successfully!");
        window.location.reload();
      } else {
        console.error(result.message || "Failed to mark equipment as returned.");
        toast.error(result.message || "Failed to mark equipment as returned.");
      }
    } catch (error) {
      console.error("Error marking equipment as returned:", error);
      toast.error("Something went wrong while marking as returned.");
    }
  };



  const handleEditReservation = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.put(
        `${config.API_BASE_URL}/equipmentReservation/updateEquipmentReservation/${selectedEvent?.equipmentReservationId}`,
        {
          selectedLocation: selectedEvent?.selectedLocation,
          equipmentName: selectedEvent?.equipmentName,
          reserveBy: selectedEvent?.reservedBy, // Send the updated reservedBy with "(Edited by Admin)"
          userEmail: selectedEvent?.userEmail,
          selectedStartDate: (new Date(selectedEvent?.start).toLocaleString()),
          selectedEndDate: (new Date(selectedEvent?.end).toLocaleString()),
          remarks: selectedEvent?.remarks,
          //noOfPersons: selectedEvent?.noOfPersons,
          purposeOfEquipment: selectedEvent?.purposeOfEquipment,
        }
      );

      toast.success(response.data.message);

      fetchEquipmentsReservation();
      handleCloseModalEdit();
    } catch (err) {
      console.error("Error updating equipment reservation:", err);
      setError(err.response?.data?.message || "Failed to update reservation");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEvent?.selectedLocation) {
      setSelectedLocation(selectedEvent.selectedLocation);
    }
  }, [selectedEvent]);

  const handleEventMount = (info) => {
    new Tooltip(info.el, {
      title: info.event.title,
      placement: "top",
      trigger: "hover",
      container: "body",
      customClass: "custom-tooltip"
    });
  };

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        padding: "10px",
        paddingLeft: "260px",
        paddingTop: "60px",
      }}
    >
      <Card
        sx={{
          width: "100%",
          borderRadius: "10px",
          borderTop: "4px solid blue",
          padding: "15px",
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ padding: "5px" }}>
          IT Equipment Reservation
        </Typography>

        <Grid container spacing={2} sx={{ padding: 1 }}>
          <Grid item xs={12} md={8}>
            <Card sx={{ borderRadius: 3, boxShadow: 2, background: "linear-gradient(to right, #F0F8FF, #F0F8FF)" }}>

              <CardContent sx={{ padding: "10px" }}>
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  initialView="dayGridMonth"
                  events={events}
                  datesSet={handleDateChange}
                  selectable={true}
                  editable={true}
                  height="auto"
                  contentHeight="auto"
                  expandRows={true}
                  eventClick={handleEventClick}

                  eventDidMount={(info) => {
                    const isReturned = info.event.extendedProps.isReturned;
                    if (isReturned) {
                      // Gray style for returned equipment
                      info.el.style.backgroundColor = "#a9a9a9"; // gray
                      info.el.style.color = "#333";
                    } else {
                      // Red for active reservations
                      info.el.style.backgroundColor = "#dc3545";
                      info.el.style.color = "#fff";
                    }
                    const colors = ["#dc3545"];
                    const randomColor = colors[Math.floor(Math.random() * colors.length)];
                    info.el.style.fontSize = "1rem";
                    info.el.style.fontWeight = "bold";
                    info.el.style.color = "#fff";
                    info.el.style.padding = "5px";
                    info.el.style.borderRadius = "8px";
                    info.el.style.textAlign = "center";
                    info.el.style.boxShadow = "1px 1px 5px rgb(255, 255, 255)";
                  }}
                  key={events.length}
                  className="custom-calendar"
                  dayCellContent={(arg) => (
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "100%",
                      padding: "5px"
                    }}>
                      <span style={{
                        fontSize: "1rem",
                        fontWeight: "bold",
                        color: "#222"
                      }}>
                        {arg.dayNumberText}
                      </span>
                    </div>
                  )}
                  dayHeaderClassNames="custom-day-header"
                  dayHeaderContent={(arg) => (
                    <div style={{
                      color: "#FFFFFF",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      width: "100%",
                      height: "100%",
                    }}>
                      {arg.text}
                    </div>
                  )}

                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card sx={{ borderRadius: 3, boxShadow: 2, padding: "10px" }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  New Reservation
                </Typography>

                <FormControl fullWidth sx={{ mb: 2 }} disabled={loading}>
                  <InputLabel>Select Location</InputLabel>
                  <Select
                    value={selectedLocation}
                    onChange={(e) => {
                      setSelectedLocation(e.target.value);
                      setEquipmentName("");
                    }}
                  >
                    <MenuItem value="Factory">Factory</MenuItem>
                    <MenuItem value="HeadOffice">Head Office</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 1 }} disabled={!selectedLocation || loading}>
                  <InputLabel>Equipment Name</InputLabel>
                  <Select
                    value={equipmentName}
                    onChange={handleEquipmentChange}
                  >
                    {loading ? (
                      <MenuItem disabled>Loading...</MenuItem>
                    ) : availableEquipments.length > 0 ? (
                      availableEquipments.map((equipment) => (
                        <MenuItem key={equipment.id} value={equipment.name}>
                          {equipment.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>No Equipments Available</MenuItem>
                    )}
                  </Select>
                </FormControl>

      {/* ✅ Modal for Jabra */}
      <Dialog open={openDialog} onClose={handleDisagree}>
        <DialogTitle>⚠️ Important Notice</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This item is not allowed outside the premises.  
            Any damage or loss will be your responsibility.  
            <br />
            Do you agree to these terms?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDisagree} color="error">
            Disagree
          </Button>
          <Button onClick={handleAgree} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>

                <TextField
                  fullWidth
                  label="Reserved By"
                  value={reservedBy}
                  sx={{ mb: 1 }}
                />

                <TextField
                  fullWidth
                  label="User Email"
                  value={userEmail}
                  sx={{ mb: 1 }}
                />

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDateTimePicker
                    label="Equipment Reservation Start Time/Date"
                    value={startDate}
                    onChange={(date) => setStartDate(date)}
                    sx={{ mb: 2, width: "100%" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    minDate={today}
                  // minTime={minTime}
                  // maxTime={maxTime}
                  />
                  <MobileDateTimePicker
                    label="Equipment Reservation End Time/Date"
                    value={endDate}
                    onChange={(date) => setEndDate(date)}
                    sx={{ mb: 2, width: "100%" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    minDate={startDate || today}
                  // minTime={minTime}
                  // maxTime={maxTime}
                  />
                </LocalizationProvider>

                {/* <TextField
                  fullWidth
                  label="No of Persons"
                  value={noOfPersons}
                  onChange={handleNoOfPersonsChange}
                  sx={{ mb: 1 }}
                  error={!!personsError}
                  helperText={personsError}
                /> */}

                <TextField
                  fullWidth
                  label="Purpose of Equipment"
                  value={purposeOfEquipment}
                  onChange={(e) => setPurposeOfEquipment(e.target.value)}
                  sx={{ mb: 1 }}
                />

                <Grid container spacing={1} sx={{ mt: 1 }}>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleBookReservation}
                      disabled={loading || isSaveDisabled}
                    >
                      Save
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setSelectedLocation("");
                        setEquipmentName("");
                        setStartDate(null);
                        setEndDate(null);
                        setPurposeOfEquipment("");
                      }}
                    >
                      Reset
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Card>
      <Footer />

      {/* {console.log("Hey", selectedEvent)} */}

      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          {selectedEvent && loggedInUser && (
            <>
              <Typography variant="h6">Reservation Details</Typography>
              <hr />

              <Typography>
                <strong>Equipment Name:</strong>
                {selectedEvent.title}
              </Typography>
              <Typography>
                <strong>Reserved By:</strong>{" "}
                {selectedEvent.extendedProps.reservedBy}
              </Typography>
              <Typography>
                <strong>User Email:</strong>{" "}
                {selectedEvent.extendedProps.userEmail}
              </Typography>
              <Typography>
                <strong>Equipment Reservation Start Time/Date</strong>{" "}
                {selectedEvent.start?.toString()}
              </Typography>
              <Typography>
                <strong>Equipment Reservation End Time/Date</strong>{" "}
                {selectedEvent.end?.toString()}
              </Typography>
              {/* <Typography>
                <strong>Remarks:</strong>
                {selectedEvent.extendedProps.remarks?.toString()}
              </Typography> */}
              {/* <Typography>
                <strong>No of People:</strong>{" "}
                {selectedEvent.extendedProps?.noOfPersons}
              </Typography> */}
              <Typography>
                <strong>Purpose Of Equipment:</strong>{" "}
                {selectedEvent.extendedProps?.purposeOfEquipment}
              </Typography>

              <Grid container spacing={1} sx={{ mt: 2 }}>
                {loggedInUser === "IT_HELPDESK" ? (
                  <>
                    <Grid item xs={3}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={handleOpenModalEdit}
                      >
                        Edit
                      </Button>
                    </Grid>
                    <Grid item xs={3}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="error"
                        onClick={() => handleDelete(selectedEvent.equipmentReservationId)}
                      >
                        Delete
                      </Button>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="success"
                        onClick={() => handleReturned(selectedEvent.equipmentReservationId)}
                      >
                        Mark Returned
                      </Button>
                    </Grid>
                  </>
                ) : String(selectedEvent?.extendedProps?.EmpCode) ===
                  localStorage.getItem("Empcode") ? (
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="warning"
                      onClick={handleOpenModalRequest}
                    >
                      Request Change
                    </Button>
                    {/* <Button
                      fullWidth
                      variant="contained"
                      color="error"
                      onClick={() => handleDelete(selectedEvent.equipmentReservationId)}
                    >
                      Cancel Reservation
                    </Button> */}
                  </Grid>
                ) : null}
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </Modal>

      {/* Edit Modal */}
      <Modal open={openModalEdit} onClose={handleCloseModalEdit}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Edit Schedule
          </Typography>

          <FormControl fullWidth sx={{ mb: 2 }} disabled={loading}>
            <InputLabel>Selected Location</InputLabel>
            <Select
              value={selectedEvent?.selectedLocation || ""}
              onChange={(e) => {
                setSelectedEvent({ ...selectedEvent, selectedLocation: e.target.value })
              }}
            >
              <MenuItem value="Factory">Factory</MenuItem>
              <MenuItem value="HeadOffice">Head Office</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 1 }} disabled={!selectedLocation || loading}>
            <InputLabel>Equipment Name</InputLabel>
            <Select
              value={selectedEvent?.equipmentName || ""}
              onChange={(e) =>
                setSelectedEvent({ ...selectedEvent, equipmentName: e.target.value })
              }
            >
              {loading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : availableEquipments.length > 0 ? (
                availableEquipments.map((equipment) => (
                  <MenuItem key={equipment.id} value={equipment.name}>
                    {equipment.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Equipments Available</MenuItem>
              )}
            </Select>
          </FormControl>

          <TextField
            label="Reserved By"
            fullWidth
            value={selectedEvent?.reservedBy || ""}
            sx={{ mb: 2 }}
          />

          <TextField
            label="User Email"
            fullWidth
            value={selectedEvent?.userEmail || ""}
            sx={{ mb: 2 }}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker
              label="Equipment Reservation Start Time/Date"
              value={dayjs(selectedEvent?.start) || null}
              onChange={(date) =>
                setSelectedEvent({ ...selectedEvent, start: date })
              }
              sx={{ mb: 2, width: "100%" }}
              format="YYYY-MM-DD HH:mm:ss"
              minDate={today}
            // minTime={minTime}
            // maxTime={maxTime}
            />
            <MobileDateTimePicker
              label="Equipment Reservation End Time/Date"
              value={dayjs(selectedEvent?.end) || null}
              onChange={(date) =>
                setSelectedEvent({ ...selectedEvent, end: date })
              }
              sx={{ mb: 2, width: "100%" }}
              format="YYYY-MM-DD HH:mm:ss"
              minDate={startDate || today}
            // minTime={minTime}
            // maxTime={maxTime}
            />
          </LocalizationProvider>

          {/* <TextField
            label="No of Persons"
            fullWidth
            value={selectedEvent?.noOfPersons || ''}
            onChange={handleNoOfPersonsChangeEdit}
            sx={{ mb: 1 }}
            error={!!editPersonsError}
            helperText={editPersonsError}
          /> */}

          <TextField
            label="Purpose of Equipment"
            fullWidth
            value={selectedEvent?.purposeOfEquipment || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, purposeOfEquipment: e.target.value })
            }
            sx={{ mb: 1 }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditReservation}
              disabled={!!editPersonsError || loading}
            >
              {loading ? "Saving..." : "Edit"}
            </Button>
            <Button
              variant="contained"
              color="inherit"
              onClick={handleCloseModalEdit}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal >

      {/* Change Request */}
      < Modal open={openModalRequest} onClose={handleCloseModalRequest} >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Request to Change the Schedule
          </Typography>

          <FormControl fullWidth sx={{ mb: 2 }} disabled={selectedEvent?.status === "pending" || loading}>
            <InputLabel>Selected Location</InputLabel>
            <Select
              value={selectedEvent?.selectedLocation || ""}
              onChange={(e) => {
                setSelectedEvent({ ...selectedEvent, selectedLocation: e.target.value });
              }}
            >
              <MenuItem value="Factory">Factory</MenuItem>
              <MenuItem value="HeadOffice">Head Office</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 1 }} disabled={selectedEvent?.status === "pending" || !selectedLocation || loading}>
            <InputLabel>Equipment Name</InputLabel>
            <Select
              value={selectedEvent?.equipmentName || ""}
              onChange={(e) => {
                setSelectedEvent({ ...selectedEvent, equipmentName: e.target.value });
              }}
            >
              {loading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : availableEquipments.length > 0 ? (
                availableEquipments.map((equipment) => (
                  <MenuItem key={equipment.id} value={equipment.name}>
                    {equipment.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Equipments Available</MenuItem>
              )}
            </Select>
          </FormControl>


          <TextField
            label="Reserved By"
            fullWidth
            value={selectedEvent?.reservedBy || ""}
            sx={{ mb: 2 }}
            disabled={selectedEvent?.status === "pending"}
          />

          <TextField
            label="User Email"
            fullWidth
            value={selectedEvent?.userEmail || ""}
            sx={{ mb: 2 }}
            disabled={selectedEvent?.status === "pending"}
          />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker
              label="Equipment Reservation Start Time/Date"
              value={dayjs(selectedEvent?.start) || null}
              onChange={(date) =>
                setSelectedEvent({ ...selectedEvent, start: date })
              }
              sx={{ mb: 2, width: "100%" }}
              format="YYYY-MM-DD HH:mm:ss"
              minDate={today}
              disabled={selectedEvent?.status === "pending"}
            // minTime={minTime}
            // maxTime={maxTime}
            />
            <MobileDateTimePicker
              label="Equipment Reservation End Time/Date"
              value={dayjs(selectedEvent?.end) || null}
              onChange={(date) =>
                setSelectedEvent({ ...selectedEvent, end: date })
              }
              sx={{ mb: 2, width: "100%" }}
              format="YYYY-MM-DD HH:mm:ss"
              minDate={startDate || today}
              disabled={selectedEvent?.status === "pending"}
            // minTime={minTime}
            // maxTime={maxTime}
            />
          </LocalizationProvider>
          {/* 
          <TextField
            label="No of Persons"
            fullWidth
            value={selectedEvent?.noOfPersons || ''}
            onChange={handleNoOfPersonsChangeEdit}
            sx={{ mb: 1 }}
            disabled={selectedEvent?.status === "pending"}
            error={!!editPersonsError}
            helperText={editPersonsError}
          /> */}

          <TextField
            label="Purpose of Equipment"
            fullWidth
            value={selectedEvent?.purposeOfEquipment || ""}
            onChange={(e) =>
              setSelectedEvent({ ...selectedEvent, purposeOfEquipment: e.target.value })
            }
            disabled={selectedEvent?.status === "pending"}
            sx={{ mb: 1 }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button
              variant="contained"
              color="primary"
              disabled={selectedEvent?.status === "pending" || !!editPersonsError}
              onClick={async () => {
                if (selectedEvent?.status === "pending") {
                  toast.warning("You have already requested a change.");
                  return;
                }

                const requestPayload = {
                  equipmentReservationId: selectedEvent.equipmentReservationId,
                  selectedLocation: selectedEvent.selectedLocation,
                  equipmentName: selectedEvent.equipmentName,
                  reserveBy: selectedEvent.reservedBy,
                  userEmail: selectedEvent.userEmail,
                  selectedStartDate: (new Date(selectedEvent.start).toLocaleString()),
                  selectedEndDate: (new Date(selectedEvent.end).toLocaleString()),
                  remarks: selectedEvent.remarks,
                  //noOfPersons: selectedEvent.noOfPersons,
                  purposeOfEquipment: selectedEvent.purposeOfEquipment,
                };

                try {
                  const response = await fetch(`${config.API_BASE_URL}/equipmentReservation/requestChange`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestPayload),
                  });

                  const result = await response.json();
                  // console.log("Server Response:", result);
                  toast.success(result.message);
                  handleCloseModalRequest()
                } catch (error) {
                  console.error("Error requesting change:", error);
                }
              }}
            >
              {selectedEvent?.status === "pending" ? "Requested" : "Request Change"}
            </Button>

            <Button
              variant="contained"
              color="inherit"
              onClick={handleCloseModalRequest}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal >
      <ToastContainer />
    </Box >
  );
};

export default EquipmentReservation;